<template lang="html">
  <div @click="removeMessage">
    <transition name="fade">
      <div v-if="visible" class="ai-hover" />
    </transition>
    <transition name="top-fade">
      <div v-if="visible" class="ai-message-wrapper">
        <div class="ai-message">
          <img v-if="icon && icon.length" class="ai-message__icon" :src="icon">
          <span>{{ message }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AiMessage',
  data() {
    return {
      visible: false,
      icon: '',
      message: '',
      timer: null
    };
  },
  mounted() {
    this.visible = true;
    this.timer = setTimeout(this.removeMessage, 1500);
  },
  methods: {
    removeMessage() {
      if (this.timer) clearTimeout(this.timer);
      this.visible = false;
      setTimeout(this.removeNode, 200);
    },
    removeNode() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
